import { AgGridComponent } from "../../../../shared/screen-components/AgGridComponent/AgGridComponent";
import { useAgGridContext } from "../../../../shared/screen-components/AgGridComponent/AgGridContext";
import AgGridStyles from "./AgGridView.module.css";

const AgGridView = () => {
  const { agGridRef } = useAgGridContext();

  return (
    <div className={AgGridStyles.agGridView}>
      <AgGridComponent
        ref={agGridRef}
        pagination={false}
        height="100%"
      />
    </div>
  );
};

export default AgGridView;
